import VaButton from './VaButton.vue'
import withConfigTransport from '../../services/config-transport/withConfigTransport'

export default withConfigTransport(VaButton)
